import type { IAngularEvent, IAugmentedJQuery, IController, IScope } from "angular";

import type { IPoint } from "App/Modules/Models";

export default class SvgPolygonDirectiveController implements IController {
    public static $inject = ["$scope", "$element", "mmSvgService"];

    public create?: boolean;

    public editable?: boolean;

    public selectable?: boolean;

    public editing?: boolean;

    public onEditing?: (args: { editing: boolean }) => void;

    public onDelete?: () => void;

    public points: IPoint[];

    public center: IPoint;

    public pointsString: string;

    private svgRoot: SVGSVGElement;

    private creating: boolean;

    constructor(private $scope: IScope, private $element: IAugmentedJQuery, private svgService: any) {}

    public $onInit() {
        this.creating = true;
        this.editing = this.create || this.editing || false;
        this.editable = this.editable || false;
        this.selectable = this.selectable || false;

        this.svgRoot = this.svgService.getSvgRoot(this.$element[0]);

        this.updatePoints();

        this.$scope.$watch("$ctrl.points", () => this.updatePoints(), true);

        this.$scope.$watch("$ctrl.editable", (newValue) => {
            if (!newValue) {
                this.editing = false;
            }
        });
    }

    public deleteClicked(): void {
        if (this.onDelete) {
            this.onDelete();
        }
    }

    public polygonClicked(): void {
        this.creating = false;
        if (this.selectable) {
            this.editing = !this.editing;
            if (this.onEditing) {
                this.onEditing({ editing: this.editing });
            }
        }
    }

    public insertPoint(index: number, event: IAngularEvent): void {
        const mousePosition: IPoint = {
            x: (event as any).clientX,
            y: (event as any).clientY,
        };
        const p = this.svgService.pointToSvgCoordinates(this.svgRoot, mousePosition);
        this.points.splice(index + 1, 0, { x: p.x, y: p.y });
    }

    public deletePoint(index: number) {
        this.points.splice(index, 1);
    }

    private updatePoints(): void {
        this.pointsString = this.pointsToSvgString(this.points);
        this.center = this.points ? this.average(this.points) : { x: 0, y: 0 };
    }

    private average(points: IPoint[]): IPoint {
        return points.reduce(
            (current: IPoint, point: IPoint) => {
                current.x += point.x / points.length;
                current.y += point.y / points.length;
                return current;
            },
            { x: 0.0, y: 0.0 },
        );
    }

    private pointsToSvgString(points: IPoint[]): string {
        if (points) {
            return points.map((p) => `${p.x},${p.y}`).join(" ");
        }
        return "";
    }
}
